module.exports = __webpack_public_path__ + "img/poster1.c3718bbe.gif";